import {Navigate} from "react-router-dom";

export default function ProtectedRoute({children}) {
  return localStorage.getItem("inner_token") ? children : <Navigate to="/staff" replace />;
}